<div class="container">
    <ng-container *ngIf="pagination.data?.length; else noData">

        <div class="list_payments">
            <div class="payment" *ngFor="let payment of pagamentos">
                <p>
                    <i class="pi pi-user"></i>
                    {{ payment?.doadorConta?.nomeUtilizador}}
                </p>
                <p>
                    <i class="pi pi-calendar"></i>
                     {{payment?.dataCriacaoFormatada}}
                </p>
                <span>
                    <!-- <i class="pi pi-wallet"></i> -->
                    <!-- {{payment?.valor| number:'1.2-2' }},00 -->
                </span>
            </div>
        </div>

        <div class="pagination-controls">
            <app-paginator-control [first]="((pagination.pageNumber ?? 1) - 1) * (pagination.pageSize ?? 10)"
                [rows]="pagination.pageSize ?? 10" [totalRecords]="pagination.totalRecords ?? 0"
                (pageChange)="onPageChange($event)">
            </app-paginator-control>
        </div>
    </ng-container>

    <ng-template #noData>
        <div class="nodata">
            <app-data-void titulo="Nenhuma doação encontrada"
                descricao="Quando este for apoiado haverá doações aqui"></app-data-void>
        </div>
    </ng-template>
</div>